import React from 'react';
import classNames from 'classnames';
import { Carousel } from 'lunchbox';
import { INSURANCE_PARTNERS } from '../../data/constant';
import './slider.scss';

const InsurancePartnerSlider = () => {
  // TODO: Connect with Graphql Data once ready
  const renderPromoSlides = (slides) =>
    slides.map((slide, index) =>
      (
        <div
          className="slide slide__item flex flex-col"
          id={`slide-insurance-partner-${index + 1}`}
          key={`slide_insurance-partner_${index + 1}`}
        >
          <div className={classNames('insurance__partner', slide.title)} />
        </div>
      ));

  return (
    <div className="shadow-lg rounded">
      <div className="text-center font-semibold text-md p-4 pt-2 border-b-2 border-lp-silver-sand lg:text-lg lg:py-2">
        Rekan Asuransi Kami
      </div>
      <Carousel
        totalSlides={INSURANCE_PARTNERS.length}
        visibleSlides={2}
        slides={INSURANCE_PARTNERS}
        renderSlides={renderPromoSlides}
        showDotGroup={false}
        isInfinite
        shouldPlay
        className="insurance__partner--container"
      />
    </div>
  );
};

export default InsurancePartnerSlider;
